import React from 'react';
import clsx from 'clsx';
import { Dropdown, Button, colors } from '@insurancemenu/imenu-components-lib';
import { DropdownOptionType, OptionsAlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types/Dropdown';
import { ChevronDown, Edit, Delete, Clipboard } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRootStore } from 'store/rootStore';
import { Cart } from 'types/cartServiceV2';
import { createStyles } from './styles';

export interface MoreDropdownProps {
  cart: Cart;
  editProposalTemplate: () => void;
}
const MoreDropdown = ({ cart, editProposalTemplate }: MoreDropdownProps): JSX.Element => {
  const classes = createStyles();

  const {
    favoriteProposalsStore: { openWarningModal, openRenameTemplateModal },
  } = useRootStore();
  const { id: cartId, cartName } = cart;

  const dropdownOptions: DropdownOptionType[] = [
    {
      value: 'editProposalTemplate',
      onOptionClick: editProposalTemplate,
      label: (
        <Button type="text" leftIconProp={<Edit />}>
          Edit Template
        </Button>
      ),
      className: classes.dropdownOption,
    },
    {
      value: 'renameProposal',
      label: (
        <Button type="text" leftIconProp={<Clipboard />}>
          Rename Template
        </Button>
      ),
      onOptionClick: (): void => {
        openRenameTemplateModal(cartName, cartId);
      },
      className: classes.dropdownOption,
    },
    {
      value: 'removeProposalTemplate',
      onOptionClick: (): void => {
        openWarningModal(cartId);
      },
      label: (
        <Button type="text" leftIconProp={<Delete />} color="custom" customColor={colors.red[600]}>
          Delete Template
        </Button>
      ),
      className: clsx(classes.dropdownOption, classes.removeOption),
    },
  ];

  return (
    <Dropdown
      name="More"
      options={dropdownOptions}
      optionsAlignment={OptionsAlignmentTypes.BOTTOM_LEFT}
      optionsWidth="20rem"
      closedElement={
        <Button
          className={clsx(classes.dropdownOpenedBtn, classes.dropdownButton)}
          color="primary"
          type="text"
          rightIconProp={<ChevronDown />}
        >
          MORE
        </Button>
      }
      openedElement={
        <Button color="primary" className={classes.dropdownButton} rightIconProp={<ChevronDown />}>
          More
        </Button>
      }
    />
  );
};

export default MoreDropdown;
